import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ConduiteService } from "../../../../../core/apps/conduite.service";
import { DynamicCrudConfig } from "../dynamic-crud.config";

/** Forme de comparaison : sans accents, sans casse, espaces réduits (« Foie  » = « foie »). */
const norm = (x: any) => String(x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim();

@Component({
	selector: "kt-dynamic-crud-dialog",
	templateUrl: "./dynamic-crud-dialog.component.html",
	styleUrls: ["./dynamic-crud-dialog.component.scss"],
})
export class DynamicCrudDialogComponent implements OnInit {
	form: FormGroup;
	erreur = ""; // échec d'écriture Firestore (règles, réseau) — affiché dans la fenêtre au lieu de rester muet

	constructor(
		public dialogRef: MatDialogRef<DynamicCrudDialogComponent>,
		private formBuilder: FormBuilder,
		private conduiteService: ConduiteService,
		@Inject(MAT_DIALOG_DATA) public data: {
			config: DynamicCrudConfig;
			id?: string;
			libelle?: string;
			list: "add" | "update" | "delete";
			existing?: string[]; // libellés déjà présents dans la liste (contrôle des doublons)
		},
	) {}

	ngOnInit() {
		this.form = this.formBuilder.group({
			libelle: [this.data.libelle || "", [Validators.required, this.pasVide, this.pasDoublon]],
		});
	}

	/** Un libellé fait uniquement d'espaces est refusé (Firestore le rejetterait après trim). */
	private pasVide = (c: AbstractControl): ValidationErrors | null =>
		String(c.value || "").trim() ? null : { vide: true }

	/** Refuse un libellé déjà présent (hors casse/accents) ; en modification, l'élément lui-même est ignoré. */
	private pasDoublon = (c: AbstractControl): ValidationErrors | null => {
		const saisi = norm(c.value);
		const courant = norm(this.data.libelle);
		if (!saisi || (this.data.list === "update" && saisi === courant)) {
			return null;
		}
		return (this.data.existing || []).some(x => norm(x) === saisi) ? { doublon: true } : null;
	}

	private echec(message: string) {
		return (e: any) => { console.error(message, e); this.erreur = `${message} : ${(e && e.message) || "erreur inconnue"}`; };
	}

	onNoClick() {
		this.dialogRef.close();
	}

	onSubmit() {
		const libelle = this.form.get("libelle").value;
		this.conduiteService
			.saveLibelleItem(this.data.config.collection, libelle)
			.then(() => this.dialogRef.close(), this.echec("Ajout impossible"));
	}

	onUpdate() {
		const libelle = this.form.get("libelle").value;
		this.conduiteService
			.updateLibelleItem(this.data.config.collection, this.data.id, libelle)
			.then(() => this.dialogRef.close(), this.echec("Modification impossible"));
	}

	onDelete() {
		this.conduiteService
			.deleteLibelleItem(this.data.config.collection, this.data.id)
			.then(() => this.dialogRef.close(), this.echec("Suppression impossible"));
	}
}
